import Vue from 'vue';

 /**
 * Global Definitions
 */
 import Components from './components/index';

 /**
  * Global Definitions
  * Local Components Which we have control off.
  */

 /** Icons --------- */
 Vue.component("icon", Components.Icons.FontAwesomeIcon);

   /** Controls --------- */
 Vue.component("accordion", Components.Controls.accordion);

 /** Views -------- */
 Vue. component("accordions", Components.Views.accordions);

 export default {};